import {filter} from 'rxjs/operators';
import {toWsMsg$, wsMsg$} from '@/ws';
import {wsLogin$} from '@/user/auth-ws';
import type {ws} from '@/types';
type WOMsg = ws.WOMsg;

wsLogin$.subscribe(() => toWsMsg$.next({method: 'wo.subscribe', params: []}));

export const woMsg$ = wsMsg$.pipe(filter((o: WOMsg) => !!o.wallets && !!o.orders));
